// extracted by mini-css-extract-plugin
export default {"switch":"toggle_switch__q1900","knob":"toggle_knob__Bxo5H","active":"toggle_active__fTHBU"};